import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions,useFetchData, convertToTimeDropDownValue } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { LmsTimeDropdownOptions } from "../../constants/GlobalConstants";

const LmsInspectionCompanyInspectionDocumentsTable = () => {
  const actionsButtons = ["add", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="inspections/company-inspection-documents"
    deleteSuffix="inspections/company-inspection-documents"
    columnLabelsDictionary={{ loanNumber: "Loan #" }}
    columnClickOptions={{ hasAttachment: { path: "inspections-inspection-company-inspection-documents/view", idProp: "id" }}}
  />;
};

const addLmsInspectionCompanyInspectionDocumentsFormFields = (myForm: BCFormController, isEdit = false) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Inspection Company Inspection", "inspections/list-nwcc-inspection", { name: "nwccinspectionId", required: true, disabled: isEdit }),
    myForm.getDropdownField("Document Log", "inspections/list-document-log", { name: "documentLogId", disabled: isEdit }),
  ]);

  if (isEdit) {
    myForm.addCenteredGroup([
      myForm.getLinkField("Document Log Download", {
        linkType: "DownloadFile",
        name: "documentLogFileName",
        link: `document/download/${myForm?.initialValues?.documentLogId}`
      }),
    ]);
  }

  myForm.addCenteredGroup([
    myForm.getCalendarField("Received On Date", { name: "receivedOn" }),
    myForm.getDropdownField("Received On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.receivedOn) }),
    myForm.getCalendarField("Date Added", { name: "dateAdded" }),
    myForm.getDropdownField("Date Added Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.dateAdded) }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Caption", { disabled: isEdit }),
    myForm.getInputField("File Type No", { disabled: isEdit }),
    myForm.getInputField("File Type", { disabled: isEdit }),
    myForm.getInputField("File Source", { disabled: isEdit })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("File No", { disabled: isEdit }),
    myForm.getInputField("Project No", { disabled: isEdit }),
    myForm.getInputField("Inspector No", { disabled: isEdit }),
    myForm.getTextareaField("Error Message", { disabled: isEdit })
  ]);
  
  myForm.addCenteredGroup([myForm.getFileField("Document", { 
    value: true, 
    documentFileName: "documentFileName",
    fileFieldName: "documentFileName",
    documentDownloadSuffix:  "inspections/company-inspection-document-download",
    name: "attachment",
    disabled: isEdit
  })]);

  return myForm;
};

const AddLmsInspectionCompanyInspectionDocumentsForm = () => {
  const inspectionCompanyInspectionDocumentsFormatter = (data) => {
    const receivedDateTime = data.receivedOn ? `${data.receivedOn?.split("T")[0]}${data.receivedOnTimeId ? data.receivedOnTimeId : "T00:00:00"}` : "";
    const addedDateTime = data.dateAdded ? `${data.dateAdded?.split("T")[0]}${data.dateAddedTimeId ? data.dateAddedTimeId : "T00:00:00"}` : "";
    return {...data, receivedOn: receivedDateTime, dateAdded: addedDateTime }; 
  };
  
  const myForm = addLmsInspectionCompanyInspectionDocumentsFormFields(new BCFormController({}, { 
    submitSuffix: "inspections/company-inspection-documents",
    submitMethod: "POST",
    dataFormatterFunc: (data) => inspectionCompanyInspectionDocumentsFormatter(data),
    payloadDataType: "FormData",
    blankWidth: 4
  }));
  const formActions = ["save-new","save-continue","save-close","close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const ViewLmsInspectionCompanyInspectionDocumentsForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`inspections/company-inspection-documents/${id}`);
  const myForm = addLmsInspectionCompanyInspectionDocumentsFormFields(new BCFormController(data, { blankWidth: 4 }), true);
  const formActions = ["close"];
  return (<LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />);
};

const LmsInspectionsInspectionCompanyInspectionDocuments = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isAdd, isView, isMainPage, isActionAllowed, id } = useParseRouteActions(params, allowedActions);  
  if (!isActionAllowed) {
    history.goBack();
  }

  return <>
    {isMainPage && <LmsInspectionCompanyInspectionDocumentsTable />}
    {isAdd && <AddLmsInspectionCompanyInspectionDocumentsForm />}
    {isView && <ViewLmsInspectionCompanyInspectionDocumentsForm id={id} />}
  </>;
};

export default LmsInspectionsInspectionCompanyInspectionDocuments;